export default __webpack_public_path__ + "static/media/Scope-6.b5b1716c.png";